// 강의(수업) 데이터 인터페이스
export interface ClassData {
    id: string;
    title: string;
    courseId: string;
    professorId: string;
    password: string;
    layout: 'LECTURE' | 'CONSULTATION' | 'PRESENTATION';
    school: string;
    targetLanguages: string[] | null;
    startTime: string | null;
    endTime: string | null;
    status: 'CREATED' | 'IN_PROGRESS' | 'ENDED';
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
    inputLanguage: string | null;
}

// 오디오 장치 인터페이스
export interface AudioDevice {
    deviceId: string;
    label: string;
}

// 언어 코드와 이름 맵핑을 위한 인터페이스
export interface Language {
    code: string;
    koreanName: string;
    nativeName: string;
}

// 연결 상태 인터페이스
export interface ConnectionState {
    isDeepgramReady: boolean;
    isStreamActive: boolean;
}

// 에러 메시지 인터페이스
export interface ErrorWithMessage {
    message: string;
}

// 에러 타입 체크 함수
export function isErrorWithMessage(error: unknown): error is ErrorWithMessage {
    return (
        typeof error === 'object' &&
        error !== null &&
        'message' in error &&
        typeof (error as Record<string, unknown>).message === 'string'
    );
}

// 에러 메시지 추출 함수
export function getErrorMessage(error: unknown): string {
    if (isErrorWithMessage(error)) {
        return error.message;
    }
    return String(error);
}
